'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _NavigationBarControl = require('../../../lib/ui/NavigationBarControl');

var _NavigationBarControl2 = _interopRequireDefault(_NavigationBarControl);

var _PasswordControl = require('../../../lib/ui/PasswordControl');

var _PasswordControl2 = _interopRequireDefault(_PasswordControl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ChangeCredentials = function ChangeCredentials(element) {
  var _this = this;

  _classCallCheck(this, ChangeCredentials);

  var fragment = document.createDocumentFragment();
  new _NavigationBarControl2.default(fragment, {
    title: 'Uw PRIM wachtwoord wijzigen',
    leftHandButtons: [{
      onclick: function onclick() {
        history.back();
      },
      icon: '\uE00D'
    }]
  });

  var checkCredentials = function checkCredentials() {
    if (!_this.oldpassword.getValue() || !_this.password1.getValue() || !_this.password2.getValue()) {
      alert('Vul uw oude en nieuwe wachtwoord in.');
      return;
    }

    if (_this.password1.getValue() !== _this.password2.getValue()) {
      alert('Uw nieuwe wachtwoorden komen niet overeen. Corrigeer uw invoer en probeer het opnieuw.');
      return;
    }

    if (_this.oldpassword.getValue() === _this.password1.getValue()) {
      alert('Uw oude en nieuwe wachtwoord mogen niet overeen komen. Kies een ander wachtwoord.');
      return;
    }

    if (_this.password1.getValue().length < 12) {
      alert('Uw nieuwe wachtwoord moet tenminste 12 tekens lang zijn vanwege veiligheid. Kies een langer wachtwoord.');
      return;
    }

    var lowercase = new RegExp(/[a-z]/g);

    if (!lowercase.test(_this.password1.getValue())) {
      alert('Uw nieuwe wachtwoord moet tenminste 1 kleine letter bevatten. Probeer opnieuw.');
      return;
    }

    var uppercase = new RegExp(/[A-Z]/g);

    if (!uppercase.test(_this.password1.getValue())) {
      alert('Uw nieuwe wachtwoord moet tenminste 1 hoofdletter bevatten. Probeer opnieuw.');
      return;
    }

    var digits = new RegExp(/\d/g);

    if (!digits.test(_this.password1.getValue())) {
      alert('Uw nieuwe wachtwoord moet tenminste 1 cijfer bevatten. Probeer opnieuw.');
      return;
    }

    var special = new RegExp(/\W/g);

    if (!special.test(_this.password1.getValue())) {
      alert('Uw nieuwe wachtwoord moet tenminste 1 speciaal teken bevatten. Probeer opnieuw.');
      return;
    }

    window.PRIM.dataAccess.isCurrentPassword(_this.oldpassword.getValue()).then(function (status) {
      switch (status) {
        case 'invalid':
          alert('Uw oude wachtwoord is onjuist. Probeer het opnieuw.');
          return;
        default:
          window.PRIM.dataAccess.setCredentials(null, _this.oldpassword.getValue());
          window.PRIM.dataAccess.externalChangePassword(_this.password1.getValue()).then(function (status) {
            switch (status) {
              default:
                alert('Uw PRIM account wachtwoord is gewijzigd. Log voortaan in met dit nieuw gekozen wachtwoord.');
                window.PRIM.dataAccess.setCredentials(null, _this.password1.getValue());
                window.PRIM.session.password = _this.password1.getValue();
                break;
            }
          }, function (e) {
            alert('Uw PRIM account wachtwoord kon niet gewijzigd worden. De server is tijdelijk niet bereikbaar. Probeer het opnieuw.');
          });
      }
    }, function (e) {
      alert('Uw PRIM account wachtwoord kon niet gewijzigd worden. De server is tijdelijk niet bereikbaar. Probeer het opnieuw.');
    });
  };

  var div = document.createElement('div');
  div.className = 'viewport';

  var p = document.createElement('p');

  if (window.PRIM.License.isDemo) {
    p.innerHTML = 'In de demonstratieversie van PRIM is het niet mogelijk om het wachtwoord te wijzigen.';
  } else {
    p.innerHTML = 'Om uw wachtwoord te wijzigen, voer hieronder uw oude wachtwoord en 2 maal het nieuwe wachtwoord in. Het nieuwe wachtwoord moet vanwege veiligheid:';
  }

  div.appendChild(p);

  if (!window.PRIM.License.isDemo) {
    var ul = document.createElement('ul');
    var li = document.createElement('li');
    li.innerHTML = 'tenminste 12 tekens lang zijn';
    ul.appendChild(li);
    li = document.createElement('li');
    li.innerHTML = 'tenminste 1 cijfer bevatten';
    ul.appendChild(li);
    li = document.createElement('li');
    li.innerHTML = 'tenminste 1 hoofdletter bevatten';
    ul.appendChild(li);
    li = document.createElement('li');
    li.innerHTML = 'tenminste 1 kleine letter bevatten';
    ul.appendChild(li);
    li = document.createElement('li');
    li.innerHTML = 'tenminste 1 speciaal teken bevatten';
    ul.appendChild(li);

    div.appendChild(ul);

    p = document.createElement('p');
    p.innerHTML = 'Het gebruik van jaartalen, adres gegevens en namen is af te raden. Woorden zijn te gebruiken zolang ze onderling met elkaar en met u persoonlijk geen verband hebben. Dit zat niet gecontroleerd worden en u dient dit zelf na te gaan.';

    div.appendChild(p);

    var fieldset = document.createElement('fieldset');
    var legend = document.createElement('legend');
    legend.innerHTML = 'Uw PRIM account wachtwoord';
    fieldset.appendChild(legend);

    this.oldpassword = new _PasswordControl2.default(fieldset, { label: 'Oud wachtwoord' });
    this.password1 = new _PasswordControl2.default(fieldset, { label: 'Nieuw wachtwoord' });
    this.password2 = new _PasswordControl2.default(fieldset, { label: 'Nieuw wachtwoord herhalen' });

    var button = document.createElement('button');
    button.innerHTML = 'Account wachtwoord wijzigen';
    button.onclick = checkCredentials;

    div.appendChild(fieldset);

    div.appendChild(button);
  }

  fragment.appendChild(div);

  element.appendChild(fragment);
};

exports.default = ChangeCredentials;


//////////////////
// WEBPACK FOOTER
// ./js/modules/start/action/ChangeCredentials.js
// module id = 76
// module chunks = 0